import tw from "tailwind-styled-components";

export const Hero = tw.h1`
  font-display
  font-normal
  not-italic
  text-6xl
  text-green-100
  leading-tighter
  tracking-tighter
  md:text-8xl
`;

export const Display = tw.h2`
  font-sans
  font-semibold
  not-italic
  text-2xl
  leading-snug
  text-blue-100
  tracking-relaxed
  md:text-5xl
`;

export const Header = tw.h3`
  font-sans
  font-medium
  not-italic
  text-lg
  leading-normal
  text-blue-100
  tracking-tight
  md:text-xl
`;

export const Lead = tw.p`
  font-sans
  font-medium
  not-italic
  text-lg
  leading-normal
  text-blue-100
  tracking-tight
  md:text-xl
`;

export const Body = tw.p`
  font-sans
  font-regular
  not-italic
  text-base
  leading-normal
  text-blue-80
  tracking-normal
`;

export const BodyBold = tw.p`
  font-sans
  font-medium
  leading-normal
  not-italic
  text-base
  text-blue-80
  tracking-normal
`;

export const Small = tw.small`
  font-sans
  font-medium
  not-italic
  text-sm
  leading-snug
  tracking-wide
`;

export const SmallBold = tw.small`
  font-sans
  font-semibold
  not-italic
  text-sm
  leading-snug
  tracking-wide
`;
